<template>
    <div class="dragon_detail_pannel" :class="{ show: show }">
        <img src="@/assets/img/game/bg_detail_pannel1.png" alt="" class="bg" />
        <!-- 标签 -->
        <div class="chat_wrap">
            <div class="chat_box">
                <img src="@/assets/img/game/bg_chat.png" alt="" class="bg" />
                <div
                    class="text_box"
                    v-for="(item, index) in tags"
                    :key="index"
                >
                    {{ item.name }}
                </div>
                <div class="radar_box" ref="radar_box"></div>
            </div>
        </div>
        <!-- 星座 -->
        <div class="constellation_wrap">
            <i class="icon_cs" :class="[constellation.ename]"></i>
            <p>{{ constellation.name }}</p>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { Bus } from '@/utils/eventBus.js';
import * as echarts from 'echarts';
var tagsChart; // 八维图
var baseOption = {
    radar: {
        shape: 'circle',
        splitArea: {
            areaStyle: {
                color: ['rgba(255, 255, 255, 0)']
            }
        },
        axisLine: {
            lineStyle: {
                color: 'rgba(255, 255, 255, 0)'
            }
        },
        splitLine: {
            lineStyle: {
                color: 'rgba(255, 255, 255, 0)'
            }
        },
        indicator: [
            { name: '', max: 100 },
            { name: '', max: 100 },
            { name: '', max: 100 },
            { name: '', max: 100 },
            { name: '', max: 100 },
            { name: '', max: 100 },
            { name: '', max: 100 },
            { name: '', max: 100 }
        ]
    },
    series: [
        {
            type: 'radar',
            color: '#ffecb7',
            symbol: 'none',
            lineStyle: {
                width: 1
            },
            data: [
                {
                    value: [0, 0, 0, 0, 0, 0, 0, 0]
                }
            ]
        }
    ]
};
export default {
    name: 'scoreTopBar',
    props: {
        // 是否显示
        show: {
            type: Boolean,
            default: false
        },
        // 标签
        tags: {
            type: Array,
            default: []
        },
        // 星座
        constellation: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            tagsData: {} // 可选标签
        };
    },
    watch: {
        tags(val) {
            this.setRadaOption();
        }
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        }
    },
    mounted() {
        this.initDataPannel();
    },
    methods: {
        ...mapMutations(['SHOW_POPUP', 'SET_LANG']),
        eventBusDemo() {
            Bus.$emit('_eventBusDemo');
        },
        // 初始化属性面板数据
        initDataPannel() {
            let $radar_box = this.$refs.radar_box;
            tagsChart = echarts.init($radar_box);
            tagsChart.setOption(baseOption);
        },
        setRadaOption() {
            let _tagsData = [];
            let _tags = this.tags;
            for (let i = 0; i < _tags.length; i++) {
                _tagsData.push(_tags[i].score);
            }
            baseOption.series[0].data[0].value = _tagsData;
            tagsChart.setOption(baseOption);
        }
    }
};
</script>

<style lang="less" scoped>
.dragon_detail_pannel {
    width: 587px;
    height: 316px;
    // background: url('~@/assets/img/game/bg_detail_pannel1.png') center no-repeat;
    // background-size: cover;
    position: absolute;
    bottom: 6px;
    left: 5px;
    transform: translate(0, 110%);
    transition: transform 0.5s;
    z-index: 2;

    &.show {
        transform: translate(0, 0);
    }

    .bg {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .chat_wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% - 132px);
        height: 100%;

        .chat_box {
            width: 220px;
            height: 220px;
            // background: url('~@/assets/img/game/bg_chat.png') center no-repeat;
            // background-size: cover;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -220/2px 0 0 -220/2px;

            .bg {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
            }

            .radar_box {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
            }

            .text_box {
                position: absolute;
                text-align: center;
                line-height: 30px;
                max-height: 60px;
                overflow: hidden;
                color: #123f4f;
                font-size: 20px;
                opacity: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                // word-break: break-all;
                font-weight: bold;
                letter-spacing: -2px;

                // 顶部
                &:nth-of-type(1) {
                    width: 280px;
                    height: 30px;
                    top: -30px;
                    left: 50%;
                    margin-left: -280/2px;
                    opacity: 1;
                }
                // 左上
                &:nth-of-type(2) {
                    width: 120px;
                    height: 60px;
                    top: 0;
                    right: 205px;
                    opacity: 1;
                    align-items: flex-end;
                }
                // 左
                &:nth-of-type(3) {
                    width: 114px;
                    height: 60px;
                    top: 50%;
                    left: -114px;
                    margin-top: -30px;
                    opacity: 1;
                }
                // 左下
                &:nth-of-type(4) {
                    width: 120px;
                    height: 60px;
                    bottom: 0;
                    right: 205px;
                    opacity: 1;
                    align-items: flex-end;
                }
                // 下
                &:nth-of-type(5) {
                    width: 280px;
                    height: 30px;
                    bottom: -30px;
                    left: 50%;
                    margin-left: -280/2px;
                    opacity: 1;
                }
                // 右下
                &:nth-of-type(6) {
                    width: 120px;
                    height: 60px;
                    bottom: 0;
                    left: 205px;
                    opacity: 1;
                    align-items: flex-start;
                }
                // 右
                &:nth-of-type(7) {
                    width: 114px;
                    height: 60px;
                    top: 50%;
                    right: -114px;
                    margin-top: -30px;
                    opacity: 1;
                }
                // 右上
                &:nth-of-type(8) {
                    width: 120px;
                    height: 60px;
                    top: 0;
                    left: 205px;
                    opacity: 1;
                    align-items: flex-start;
                }
            }
        }
    }

    .constellation_wrap {
        position: absolute;
        top: 0;
        right: 0;
        width: 132px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .icon_cs {
            display: block;
            width: 130px;
            height: 130px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            // 白羊
            &.aries {
                background-image: url('~@/assets/img/game/icon_xz/icon_baiyang.png');
            }
            // 处女
            &.virgo {
                background-image: url('~@/assets/img/game/icon_xz/icon_chunv.png');
            }
            // 金牛
            &.taurus {
                background-image: url('~@/assets/img/game/icon_xz/icon_jinniu.png');
            }
            // 巨蟹
            &.cancer {
                background-image: url('~@/assets/img/game/icon_xz/icon_juxie.png');
            }
            // 摩羯
            &.capricornus {
                background-image: url('~@/assets/img/game/icon_xz/icon_mojie.png');
            }
            // 射手
            &.sagittarius {
                background-image: url('~@/assets/img/game/icon_xz/icon_sheshou.png');
            }
            // 狮子
            &.leo {
                background-image: url('~@/assets/img/game/icon_xz/icon_shizi.png');
            }
            // 双鱼
            &.pisces {
                background-image: url('~@/assets/img/game/icon_xz/icon_shuangyu.png');
            }
            // 双子
            &.gemini {
                background-image: url('~@/assets/img/game/icon_xz/icon_shuangzi.png');
            }
            // 水瓶
            &.aquarius {
                background-image: url('~@/assets/img/game/icon_xz/icon_shuiping.png');
            }
            // 天秤
            &.libra {
                background-image: url('~@/assets/img/game/icon_xz/icon_tiancheng.png');
            }
            // 天蝎
            &.scorpio {
                background-image: url('~@/assets/img/game/icon_xz/icon_tianxie.png');
            }
        }

        p {
            font-size: 24px;
            color: #123f4f;
            margin-bottom: 20px;
            font-weight: bold;
            letter-spacing: -2px;
        }
    }
}
</style>
